import React from 'react';
import { useDispatch } from 'react-redux';
import { UploaderImage } from '../_atoms';
import { BooksInAddind } from './books_in_adding';
import { replacePicture } from '../redux/reducers/picturesReducer';
import '../styles/books_in_exemplar.scss';

export const BooksInExemlar = ({
  images,
  num,
  deletePhoto,
  addPhoto,
  saveCurrentPictOrder,
  changePictOrder,
  showImageCopies,
}) => {
  const dispatch = useDispatch();
  const changeQuantity = photo => dispatch(replacePicture({ photo, massName: 'images' }));

  const nameMass = 'images';
  const pictMass = [];
  for (let i = 0; i < 4; i += 1) {
    pictMass.push(
      <UploaderImage
        key={i}
        i={i}
        nameMass={nameMass}
        addPhoto={addPhoto}
        deletePhoto={deletePhoto}
        item={images[i]}
        saveCurrentPictOrder={saveCurrentPictOrder}
        changePictOrder={changePictOrder}
      >
        <p className="books-in-exemplar-number">{num + i}</p>
        {!!showImageCopies && !!images[i] && (
          <BooksInAddind
            numberOfCopies={images[i]?.numberOfCopies}
            handleChange={e => changeQuantity({ ...images[i], numberOfCopies: e.target.value })}
          />
        )}
      </UploaderImage>
    );
  }

  return (
    <div className="books-in-exemplar">
      {pictMass[0]}
      {pictMass[1]}
      {pictMass[2]}
      {pictMass[3]}
    </div>
  );
};
